import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsGridTableCaption = styled<any, any>(
    'caption',
    'documentsGridTableCaption',
    'documentsGrid'
)`
    ${propStyles};
`;

export default DocumentsGridTableCaption;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsGridTableCaption.tsx